import { createRoot } from 'react-dom/client'
import { App } from '../components/App'
import './application.css'

const container = document.getElementById('react-root')

if (container) {
  const root = createRoot(container)
  root.render(<App />)
} else {
  console.error('Could not find react-root element')
}
